export enum KonnekAppThemes {
  LIGHT = "light",
  DARK = "dark",
}
